import { render } from "./CreateIpv4SubnetForNetwork.vue?vue&type=template&id=0d2e1be4&scoped=true"
import script from "./CreateIpv4SubnetForNetwork.vue?vue&type=script&lang=js"
export * from "./CreateIpv4SubnetForNetwork.vue?vue&type=script&lang=js"

import "./CreateIpv4SubnetForNetwork.vue?vue&type=style&index=0&id=0d2e1be4&lang=scss&scoped=true"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2e1be4"]])

export default __exports__